import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as styles from './index.vanilla.css'

interface Props {
  participants: number
  respondents: number
  score: number
  scoreDescription: string
  showMaxScore?: boolean
}

const AnalyticsDescription = ({
  participants,
  respondents,
  score,
  scoreDescription,
  showMaxScore = false,
}: Props) => {
  return (
    <Box className={styles.score}>
      <Box className={styles.scoreHeader}>
        <span>{score}</span>
        {showMaxScore && <span className={styles.maxScore}>/10</span>}
      </Box>
      <span>{scoreDescription}</span>
      {!!participants && (
        <Box gap="s4" flexDirection="row">
          <span>{i18n.t('engagement_insights.survey_widget.analytics.participation')}</span>
          <span className={styles.participation}>
            {respondents}/{participants}
          </span>
        </Box>
      )}
    </Box>
  )
}

export default AnalyticsDescription
